import axios from "axios";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { Button, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import InputGroup from 'react-bootstrap/InputGroup';


const AdminTraining = () => {
  const [getTrainingEnquiryy, setgetTrainingEnquiryy] = useState([]);
  const [nochangedata, setnochangedata] = useState([])
  const getTrainingEnquiry = async () => {
    let res = await axios.get(
      "/api/user/getTrainingEnquiry"
    );
    if (res.status === 200) {
      setgetTrainingEnquiryy(res.data.getTrainingEnquiry);
      setnochangedata(res.data.getTrainingEnquiry);
    }
  };
  //delete method
  const [show, setShow] = useState(false);
  const [Data, setData] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = (data) => {
    setShow(true);
    setData(data);
  };

  const DeletTrainingenquiry = async () => {
    try {
      const config = {
        url: "/user/DeletTrainingenquiry/" + Data,
        method: "delete",
        baseURL: "/api",
        header: { "content-type": "application/json" },
      };
      await axios(config).then((res) => {
        if (res.status === 200) {
          alert("successfully delete");
          getTrainingEnquiry();
          handleClose();
        }
      });
    } catch (error) {
      console.log(error);
      alert(error.response.data.error);
    }
  };
  useEffect(() => {
    getTrainingEnquiry();
  }, []);
  console.log(getTrainingEnquiryy);
  const [search, setSearch] = useState("");

  const handleFilter = (e) => {
    if (e.target.value != "") {
      setSearch(e.target.value);
      const filterTable = nochangedata.filter((o) =>
        Object.keys(o).some((k) =>
          String(o[k]).toLowerCase().includes(e.target.value.toLowerCase())
        )
      );
      setgetTrainingEnquiryy([...filterTable]);
    } else {
      setSearch(e.target.value);
      setgetTrainingEnquiryy([...nochangedata]);
    }
  };
  return (
    <>

      <div className="container  mt-5">
        <div className="row mb-3">
          <div className="col-md-4">
            <div className="do-sear mt-4">
              <InputGroup className="mb-3">
                <InputGroup.Text id="basic-addon1"><FontAwesomeIcon icon={faMagnifyingGlass} /></InputGroup.Text>
                <Form.Control
                  placeholder="Search"
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  onChange={handleFilter}
                />
              </InputGroup>
            </div>
          </div>

        </div>
        <div className="row">
          <Table striped bordered hover style={{ textAlign: "center" }}>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Training Type</th>
                <th>Name</th>
                <th>Email</th>
                <th>Contact No.</th>
                <th>Message</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {getTrainingEnquiryy?.map((item, i) => {
                return (
                  <tr>
                    <td>{++i}</td>
                    <td>{item?.TraingType}</td>
                    <td>{item?.TrainingName}</td>
                    <td>{item?.TrainingEmail} </td>

                    <td>{item?.TrainingPhone}</td>
                    <td>{item?.TrainingMsg}</td>
                    <td>
                      <FontAwesomeIcon
                        icon={faTrash}
                        style={{ color: "red" }}
                        onClick={() => {
                          handleShow(item?._id);
                        }}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Warning</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h3 style={{ color: "#c0392b" }}>Do You Really Want To Delete...</h3>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button onClick={DeletTrainingenquiry}>Delete </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AdminTraining;
